import { Component, OnInit, ViewEncapsulation, inject } from '@angular/core';
import { Router, RouterModule } from '@angular/router';

@Component({
  selector: 'app-catalogues',
  templateUrl: './catalogues.component.html',
  styleUrls: ['./catalogues.component.scss'],
  imports: [RouterModule],
  encapsulation: ViewEncapsulation.Emulated
})
export class CataloguesComponent implements OnInit {
  private router = inject(Router);
  
  ngOnInit(): void {
    console.log('Catalogos')
  }

  ngDoCheck(): void {
    if(this.router.url == '/catalogues'){
      this.router.navigate(['catalogues/menu']);
    }
  }
}
